import * as React from 'react';
import { getAppProgressBarStyles } from './AppProgressBar.styles';
import { ProgressIndicator } from 'office-ui-fabric-react';
import { AppProgressBarProps } from './AppProgressBar.props';

export const AppProgressBar: React.FunctionComponent<AppProgressBarProps> = (props: AppProgressBarProps): JSX.Element => {
  const { ariaValueText, barHeight, label, description, percentComplete, styles } = props;
  const appProgressIndicatorStyles = getAppProgressBarStyles(styles);

  return (
    <ProgressIndicator
      ariaValueText={ariaValueText}
      barHeight={barHeight}
      label={label}
      description={<div role="alert">{description}</div>}
      percentComplete={percentComplete}
      styles={appProgressIndicatorStyles}
    />
  );
}